export class Pagination {
    currentPage = 1;
    pageSize = 10;
    totalRecords = 0;
    pageInput = 1;
    visiblePages: number[] = [];
}